import ApplicationController from './application_controller'
import $ from 'jquery'

export default class extends ApplicationController
  @values = {current: Number}

  # Create accordion
  initialize: ->
    $(@element).accordion heightStyle: 'content', active: @currentValue || 0, collapsible: true, icons: false
